import styled from 'styled-components'

import { PostAdCTA } from '@/components/shared/post-ad/PostAdCTA'
import { BodyText } from '@/ui/atoms/body-text'
import { Button } from '@/ui/atoms/button'
import { HeadlineText } from '@/ui/atoms/headline-text'
import { MEDIA_QUERIES } from '@/ui/constants/mediaQueries'
import carDesktopImage from '~/public/next-assets/images/brp-landing/car-desktop.png'
import carMobileImage from '~/public/next-assets/images/brp-landing/car-mobile.png'

const BG_IMAGE_PADDING_SMALL = '17.9rem'

export const CarsBannerContainer = styled.div(
  ({ theme }) => `
  position: relative;
  background-color: ${theme.colors.purple.primary};
  padding: ${theme.spacing.default};
  padding-top: ${theme.spacing.large};
  padding-bottom: ${BG_IMAGE_PADDING_SMALL};
  border-radius: ${theme.borderRadius.medium};

  ${MEDIA_QUERIES(theme).medium}{
    padding-inline: ${theme.spacing.large};
    padding-block: ${theme.spacing.xLarge};
  }
  ${MEDIA_QUERIES(theme).large}{
    padding-inline: 3.8rem;
    padding-top: 4.6rem;
    padding-bottom: ${theme.spacing.giant};
  }
`
)

export const CarsBannerBgImage = styled.div(
  ({ theme }) => `
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  padding-bottom: ${BG_IMAGE_PADDING_SMALL};
  background-image: url(${carMobileImage.src});
  background-position: bottom;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: ${theme.borderRadius.medium};

  ${MEDIA_QUERIES(theme).medium}{
    top: 0;
    left: 50%;
    right: 0;
    bottom: unset;
    padding-bottom: 31.9rem;
    background-image: url(${carDesktopImage.src});
    background-position: 0% top;
  }
`
)

export const CarsBannerContentWrapper = styled.div`
  position: relative;
  z-index: 1;
`

export const CarsBannerTextWrapper = styled.div(
  ({ theme }) => `
  ${MEDIA_QUERIES(theme).medium}{
    width: 50%;
    padding: 0;
    padding-left: 0.2rem;
  }
`
)

export const CarsBannerHeadlineText = styled(HeadlineText)(
  ({ theme }) => `
  line-height: ${theme.spacing.xLarge};
  font-size: ${theme.typography.headline.xLarge.fontSize};

  ${MEDIA_QUERIES(theme).medium}{
    line-height: 4.6rem;
    font-size: 4.4rem;
    letter-spacing: 0.04rem;
  }
`
)

export const CarsBannerHeadlineSubText = styled.span(
  ({ theme }) => `
  color: ${theme.colors.yellow.light1};
`
)

export const CarsBannerBodyText = styled(BodyText)(
  ({ theme }) => `
  margin-top: 0.9rem;

  ${MEDIA_QUERIES(theme).medium}{
    margin-top: 1.2rem;
    line-height: 3.2rem;
  }
`
)

export const CarsBannerTabsOuterWrapper = styled.div(
  ({ theme }) => `
    background-color: ${theme.colors.white};
    margin-top: ${theme.spacing.xLarge};
    border-radius: ${theme.borderRadius.medium};

    ${MEDIA_QUERIES(theme).medium}{
      padding-top: ${theme.spacing.default};
      margin-top: ${theme.spacing.husky};
    }
  `
)

export const BannerSellCarBodyText = styled(BodyText)(
  ({ theme }) => `
  ${MEDIA_QUERIES(theme).medium}{
    min-height: 7.2rem;
  }
  ${MEDIA_QUERIES(theme).large}{
    min-height: 4.8rem;
  }
  `
)

export const SmallImageWrapper = styled.div(
  ({ theme }) => `
  ${MEDIA_QUERIES(theme).large}{
    display: none;
  }
  `
)

export const LargeImageWrapper = styled.div(
  ({ theme }) => `
  display: none;
  ${MEDIA_QUERIES(theme).large}{
    display: block;
  }
  `
)

export const CarsBannerPostAdCTA = styled(PostAdCTA)`
  min-height: 4.8rem;
`

export const CarsBannerICOCTA = styled(Button)`
  padding: 0.9rem 1.6rem;
`
